import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/rootReducer';

export const selectErrors = (state: RootState) => state.errors;

export const selectError = createSelector(selectErrors, (errors) => errors.error);
